import React from 'react';

const HOURS = Array.from({ length: 24 }, (_, i) => String(i).padStart(2, '0'));
const MINUTES = Array.from({ length: 60 }, (_, i) => String(i).padStart(2, '0'));

export default function TimeSelect({ value, onChange, placeholder = 'Select time' }) {
  const [hour, minute] = value ? value.split(':') : ['', ''];

  const handleHourChange = (newHour) => {
    if (!newHour) { onChange(''); return; }
    onChange(`${newHour}:${minute || '00'}`);
  };

  const handleMinuteChange = (newMinute) => {
    if (!hour) { onChange(''); return; }
    onChange(`${hour}:${newMinute}`);
  };

  return (
    <div className="time-select-group">
      <select value={hour} onChange={(e) => handleHourChange(e.target.value)} className="time-select-hour">
        <option value="">HH</option>
        {HOURS.map(h => <option key={h} value={h}>{h}</option>)}
      </select>
      <span className="time-select-colon">:</span>
      <select value={minute} onChange={(e) => handleMinuteChange(e.target.value)} className="time-select-minute">
        <option value="">MM</option>
        {MINUTES.map(m => <option key={m} value={m}>{m}</option>)}
      </select>
    </div>
  );
}